#import '../../fragments/userProfile.fragment.graphql'

mutation checkout($items: [ShoppingCartItemInput]) {
  checkout(input: { items: $items }) {
    userProfile {
      ...UserProfileFragment
    }
  }
}
